import project from './project';
import { vec3 } from 'gl-matrix';

export default function getDepthOffset(item) {
  const gap = {
    width: 0,
    height: 0,
    depth: item.z,
  };

  const gapVertices = project.calculateVertices(gap);
  let gapProjectedVertices = gapVertices.map(project.point);
  const backBottomLeft = gapProjectedVertices[4];
  gapProjectedVertices = gapProjectedVertices.map(vertex =>
    vec3.sub(vec3.create(), vertex, backBottomLeft)
  );

  const x = gapProjectedVertices[4][0] - gapProjectedVertices[0][0];
  const y = gapProjectedVertices[4][1] - gapProjectedVertices[0][1];

  return { x, y };
}
